import OfficialAddIngredientModal from './OfficialAddIngredientModal'

export default OfficialAddIngredientModal
